/**
 * P14 (team feedback fb 16, Pedro 2026-10-10): task urgency. ONE map for every task
 * surface (the To-Do hub, the Agreement Tasks tab, the task form), so the names and
 * colours read the same everywhere (§3h/§3j). Stored as a number (migration 0100):
 * 1 = High, 2 = Medium, 3 = Low, default Medium — "most urgent first" is ascending.
 */
export const DEFAULT_URGENCY = 2;

export const URGENCY_LEVELS: { value: number; label: string; color: string }[] = [
  { value: 1, label: 'High', color: 'red' },
  { value: 2, label: 'Medium', color: 'orange' },
  { value: 3, label: 'Low', color: 'gray' },
];

const BY_VALUE = new Map(URGENCY_LEVELS.map((l) => [l.value, l]));

export const urgencyLabel = (u: number | null | undefined): string =>
  BY_VALUE.get(u ?? DEFAULT_URGENCY)?.label ?? String(u);

export const urgencyColor = (u: number | null | undefined): string =>
  BY_VALUE.get(u ?? DEFAULT_URGENCY)?.color ?? 'gray';

/** Select / multi-select options (string values, as Mantine expects). */
export const URGENCY_OPTIONS = URGENCY_LEVELS.map((l) => ({ value: String(l.value), label: l.label }));
